// export const dummyAccessToken = JSON.stringify({ access_token: "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpZCI6IjVlMmZiMzQwY2FhOTZjNWVmYzY5MmRhNyIsInVzZXJUeXBlIjp7Il9pZCI6IjVkOGRlMjExMTBiYTkxMDNkMjFkMWE4NSIsIm5hbWUiOiJQcm9qZWN0IE1hbmFnZW1lbnQgVW5pdCJ9LCJuYW1lIjoiUE1VIFRhc2tmb3JjZSIsImFjY291bnRUeXBlIjoiU3VwZXIgVXNlciIsInBlcm1pc3Npb25zIjpbXSwicHJvamVjdElkIjoiNjQ0OGMxZTYzNDNhMWI4ZTRjNTJlNjY1IiwiaWF0IjoxNzEyMTUyMzI5fQ.Xo - X6xNdwd7Bh6wWP1wMx7uMzGqLl - NWUZcbDVB_svg" });
export const dummyAccessToken = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpZCI6IjVlMmZiMzQwY2FhOTZjNWVmYzY5MmRhNyIsInVzZXJUeXBlIjp7Il9pZCI6IjVkOGRlMjExMTBiYTkxMDNkMjFkMWE4NSIsIm5hbWUiOiJQcm9qZWN0IE1hbmFnZW1lbnQgVW5pdCJ9LCJuYW1lIjoiUE1VIFRhc2tmb3JjZSIsImFjY291bnRUeXBlIjoiU3VwZXIgVXNlciIsInBlcm1pc3Npb25zIjpbXSwicHJvamVjdElkIjoiNjM0ZDM0OTA4ZDFiZDkwOGY0OGIzMTVhIiwiaWF0IjoxNzEyMTUyMzI5fQ.c9_auk1fvMWqUC39CrSrVt_QurInBVmfrzI0eDRCu7A";

export const dummyCurrentProjectDetails = { "displayTitle": "Enterprise Support Services", "themeColor": "#EF5A20", "funderLogo": "", "_id": "6448c1e6343a1b8e4c52e665" };

export const dummyProjectId = "6448c1e6343a1b8e4c52e665";

export const dummyUserData = {
    "address": {
        "state": [],
        "district": []
    },
    "location": {
        "latitude": 24.2028,
        "longitude": 10.4418,
        "label": ""
    },
    "id": "5e2fb340caa96c5efc692da7",
    "status": "Active",
    "websiteUrl": "",
    "isUserVerified": false,
    "permissions": [],
    "profilePicture": "",
    "admin": false,
    "accountType": "Super User",
    "fellowAccessType": "Full",
    "memberCount": 0,
    "saarthiAccess": "",
    "addedOn": "2020-01 - 24T17: 41:08 +05: 30",
    "hasAccessToApp": [
        "Swati"
    ],
    "deleted": false,
    "_id": "5e2fb340caa96c5efc692da7",
    "fullName": "PMU Taskforce",
    "email": "support @letsendorse.com",
    "mobileNumber": "7387193190",
    "addedBy": {
        "websiteUrl": "",
        "_id": "5db96a096626035153c8683a",
        "fullName": "Monika Shukla"
    },
    "userType": {
        "_id": "5d8de21110ba9103d21d1a85",
        "name": "Project Management Unit"
    },
    "type": "le",
    "organisation": {
        "websiteUrl": "https://www.letsendorse.com",
        "logo": "https://www.letsendorse.com/images/letsEndorse-Logo-Black-Transparent.png",
        "_id": "5dd4e48aba02ad50c686ba38",
        "name": "LetsEndorse"
    },
    "updatedAt": "2024-03-15T06:44:02.025Z",
    "createdAt": "2020-01-28T04:06:24.474Z",
    "__v": 0,
    "district": [],
    "state": [],
    "hasAccessToProject": [
        "634d34908d1bd908f48b315a"
    ],
    "hasAccessToProjects": {
        "634d34908d1bd908f48b315a": {
            "status": "Active",
            "addedAt": "2020-01-28T04:06:24.474Z",
            "addedBy": "5db96a096626035153c8683a",
            "userType": "5d8de21110ba9103d21d1a85",
            "updatedAt": "2023-06-27T19:52:30+05:30",
            "district": [],
            "state": [],
            "updatedBy": "5e2fb340caa96c5efc692da7",
            "fellowAccessType": "Full",
            "reportingTo": ""
        },
        "6448c1e6343a1b8e4c52e665": {
            "status": "Active",
            "addedAt": "2023-04-26T06:17:53.778Z",
            "addedBy": null,
            "userType": "5d8de21110ba9103d21d1a85",
            "updatedAt": "2023-04-26T06:17:53.778Z",
            "district": "Bangalore Urban",
            "state": "Karnataka",
            "updatedBy": null
        },
        "645e309d82bcc778c0d873c7": {
            "status": "Active",
            "addedAt": "2023-04-26T06:17:53.778Z",
            "addedBy": null,
            "userType": "5d8de21110ba9103d21d1a85",
            "updatedAt": "2023-04-26T06:17:53.778Z",
            "district": "Bangalore Urban",
            "state": "Karnataka",
            "updatedBy": null
        },
        "64633346af3f097d201c2f1e": {
            "addedAt": "2023-05-16T07:39:50.984Z",
            "updatedAt": "2023-05-16T07:39:50.984Z",
            "district": [],
            "state": [],
            "userType": "5d8de21110ba9103d21d1a85",
            "status": "Active"
        },
        "64c8aab70e016c7c52d8bc5e": {
            "addedAt": "2023-08-01T06:48:23.250Z",
            "updatedAt": "2023-08-01T06:48:23.251Z",
            "district": [],
            "state": [],
            "userType": "5d8de21110ba9103d21d1a85",
            "status": "Active"
        },
        "65f3ee326de91374da351ab5": {
            "addedAt": "2024-03-15T06:44:02.025Z",
            "updatedAt": "2024-03-15T06:44:02.025Z",
            "district": [],
            "state": [],
            "userType": "5d8de21110ba9103d21d1a85",
            "status": "Active"
        }
    },
    "reportingTo": null,
    "newKey": "2024-04-03T13:52:09.311Z"
}